import React, { useState } from "react";
import classnames from "classnames";
import { useFormikContext, useField } from "formik";
import { BUILDER_INTENT, BUILDER_ENTITY } from "utils/constants/builder";
import set from "lodash/set";
import get from "lodash/get";
import { STATE_KEYS } from "utils/constants/state";
import EntityHeader from "../EntityHeader";
import HoverIconButton from "components/HoverIconButton";
import { useHoverProps } from "utils/hooks";

const ThemeBlockItem = (props) => {
  const { values, setValues } = useFormikContext();

  const blockSettingsVisible = get(values, STATE_KEYS.EDITOR.VISIBILITY_PANEL);

  const { name } = props;

  const [_, meta] = useField(name);
  const { value } = meta;
  const active = value === BUILDER_ENTITY.PAGE_THEME;
  const [hover, setHover] = useState();

  const openBlockSettings = () => {
    const updatedValues = { ...values };
    set(updatedValues, STATE_KEYS.EDITOR.INTENT, BUILDER_INTENT.PAGE_THEME);
    set(updatedValues, STATE_KEYS.EDITOR.VISIBILITY_PANEL, true);
    set(
      updatedValues,
      STATE_KEYS.EDITOR.ACTIVE_BLOCK,
      BUILDER_ENTITY.PAGE_THEME
    );
    setValues(updatedValues);
  };
  const hoverProps = useHoverProps({ hover, setHover });

  const containerProps = {
    className: classnames(
      "w-100 flex flex-row items-center pa3 bg-white bb b--black-05 bh--inset pointer relative",
      {
        "bg-content--secondary": hover || active,
        "bg-white": !hover,
        "pointer": hover && !active
      }
    ),
    ...hoverProps
  };

  const headerProps = {
    onClick: openBlockSettings,
    uid: "theme",
    title: "Set theme",
    draggable: false,
    compress: blockSettingsVisible
  };

  const deadZoneClick = (
    <div
      onClick={openBlockSettings}
      style={{ height: 40 }}
      className="flex w-100 h-100 o-0 pointer pb2"
    >
      _
    </div>
  );

  const showBlockActions = active || hover;

  return (
    <div {...containerProps}>
      <EntityHeader {...headerProps} />
      {showBlockActions && !blockSettingsVisible && (
        <div className="w-100 flex flex-row items-center justify-end absolute bottom-0 right-0 pr2">
          {deadZoneClick}
          <div className="flex flex-row pb2">
            <HoverIconButton
              type="settings"
              tooltip="Settings"
              onClick={openBlockSettings}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ThemeBlockItem;
